const checkYearBoundaries = (years: number[], date: Date, type: "increase" | "reduce"): boolean => {
  const monthIndex = date.getMonth(); /* month range: 0 - 11 */
  const year = date.getFullYear();
  const updatedMonth = monthIndex + (type === "increase" ? 1 : -1);
  let yearToCheck = year;

  if (updatedMonth < 0) {
    yearToCheck -= 1;
  }

  if (updatedMonth > 11) {
    yearToCheck += 1;
  }

  return years.includes(yearToCheck);
};
export default checkYearBoundaries;
